import * as React from "react";
const SvgCross = props => <svg xmlns="http://www.w3.org/2000/svg" width={8} height={9} viewBox="0 0 8 9" {...props}><path fillRule="evenodd" d="M4 4.83 7.09 8l.7-.71-3.1-3.18L8 .71 7.3 0 4 3.4.7 0 0 .72 3.3 4.1.21 7.29l.7.71z" clipRule="evenodd" /></svg>;
export default SvgCross;